import { certidoesPositivasSection } from './certidoesPositivasSections';

// Declarações/termos obrigatórios reutilizados por todos os pedidos de Seleção e Inscrição.
// `declaroVerdade` e `concordaLgpd` são sempre exigidos, então entram automaticamente.
// O restante é escolhido por chave, na ordem em que deve aparecer, via termosStep(chaves).
// Ex: termosStep(['assinaturaDigital'])
//     termosStep(['validadeCertidoes', 'assinaturaDigitalComIdoneidade'])

const DECLARACOES_CATALOGO = {
  assinaturaDigital: {
    type: 'checkbox',
    name: 'cienteAssinaturaDigital',
    label: 'DECLARO que o requerimento foi assinado digitalmente conforme exigido, utilizando certificado digital Gov.br ou certificado em nuvem.',
    required: true
  },
  assinaturaDigitalComIdoneidade: {
    type: 'checkbox',
    name: 'cienteAssinaturaDigital',
    label: 'DECLARO que o Requerimento, a Declaração de Autenticidade e a Declaração de Idoneidade foram assinados digitalmente conforme exigido, utilizando certificado digital Gov.br ou certificado em nuvem.',
    required: true
  },
  validadeCertidoes: {
    type: 'checkbox',
    name: 'cienteValidadeCertidoes',
    label: 'ESTOU CIENTE de que as certidões apresentadas devem estar dentro do prazo de validade (30 a 90 dias) e que certidões vencidas implicarão no indeferimento do meu protocolo.',
    required: true
  },
  fotografias: {
    type: 'checkbox',
    name: 'cienteFotografias',
    label: 'ESTOU CIENTE de que as fotografias 3x4 devem seguir os padrões exigidos (fundo branco, papel fosco, trajes adequados) sob pena de rejeição do pedido.',
    required: true
  }
};

const termosObrigatoriosSection = (chavesExtras = ['assinaturaDigital']) => ({
  title: 'Declarações Obrigatórias',
  fields: [
    {
      type: 'checkbox',
      name: 'declaroVerdade',
      label: 'DECLARO que as informações prestadas neste requerimento são verdadeiras e estou ciente de que a falsidade ideológica constitui crime previsto no Código Penal, sujeitando-me às penalidades da lei.',
      required: true
    },
    {
      type: 'checkbox',
      name: 'concordaLgpd',
      label: 'CONCORDO com o tratamento dos meus dados pessoais conforme a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018), para as finalidades relacionadas ao processamento deste requerimento.',
      required: true
    },
    ...chavesExtras.map(chave => {
      const declaracao = DECLARACOES_CATALOGO[chave];
      if (!declaracao) {
        throw new Error(`termosObrigatoriosSection: declaração "${chave}" não existe no catálogo`);
      }
      return { ...declaracao };
    })
  ]
});

// `certidoesPositivas: true` acrescenta, antes das declarações, a pergunta de
// quais Certidões de Distribuição resultaram positivas (ver certidoesPositivasSections.js).
export const termosStep = (chavesExtras = ['assinaturaDigital'], { id = 'termos_condicoes', title = 'Termos e Condições', certidoesPositivas = false } = {}) => ({
  id,
  title,
  sections: [
    ...(certidoesPositivas ? [certidoesPositivasSection()] : []),
    termosObrigatoriosSection(chavesExtras)
  ]
});
